import styles from "./Page.module.css";

const Page = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="w-screen overflow-hidden text-white relative z-0">
      <div className={styles.contentWrapper}>
        {children}
        {/* <div className="h-full overflow-y-auto">{children}</div> */}
      </div>
    </div>
  );
};

export default Page;
